export type MarketingConsent = 'granted' | 'denied' | 'unknown';

const CONSENT_KEY = ['st', 'marketing', 'consent', 'v1'].join('_');

export const getMarketingConsent = (): MarketingConsent => {
  if (typeof window === 'undefined') return 'unknown';
  const value = window.localStorage.getItem(CONSENT_KEY);
  if (value === 'granted' || value === 'denied') return value;
  return 'unknown';
};

export const setMarketingConsent = (value: Exclude<MarketingConsent, 'unknown'>): void => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(CONSENT_KEY, value);
};
